module.exports = __webpack_public_path__ + "img/spinner.4f32a2f9.svg";